import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

export default function OnBilgilendirmeFormuPage() {
  return (
    <div className="min-h-screen bg-gray-50 font-poppins">
      <Header />

      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm p-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">
              Ön Bilgilendirme Formu
            </h1>

            <div className="space-y-8">
              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Satıcı Bilgileri</h2>
                <div className="bg-gold-50 p-6 rounded-lg">
                  <p><strong>Unvan:</strong> Emin Kuyumculuk</p>
                  <p><strong>Adres:</strong> Kamil Ocak Mah. Divrik Cad. 45/A Keçiören / ANKARA</p>
                  <p><strong>Telefon:</strong> 0531 603 68 91</p>
                  <p><strong>E-posta:</strong> info@eminkuyumculuk.com.tr</p>
                  <p><strong>Website:</strong> www.eminkuyumculuk.com.tr</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Teslimat ve İade Bilgileri</h2>
                <div className="space-y-4 text-gray-600">
                  <p><strong>Teslimat Süresi:</strong> Siparişiniz 1-3 iş günü içerisinde kargoya verilir.</p>
                  <p><strong>Kargo Ücreti:</strong> 500 TL ve üzeri alışverişlerde ücretsiz kargo.</p>
                  <p><strong>İade Süresi:</strong> Ürünü teslim aldığınız tarihten itibaren 14 gün içinde iade edebilirsiniz.</p>
                  <p><strong>İade Koşulları:</strong> Ürün orijinal ambalajında, hiç kullanılmamış ve etiketleri sağlam olmalıdır.</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Ödeme Yöntemleri</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-medium text-gray-800 mb-2">Kredi Kartı</h3>
                    <p className="text-sm text-gray-600">Visa, Mastercard, American Express kabul edilir.</p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-medium text-gray-800 mb-2">Havale/EFT</h3>
                    <p className="text-sm text-gray-600">Banka hesabımıza havale yapabilirsiniz.</p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-medium text-gray-800 mb-2">Kapıda Ödeme</h3>
                    <p className="text-sm text-gray-600">Nakit veya kredi kartı ile ödeyebilirsiniz.</p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-medium text-gray-800 mb-2">Taksit İmkanı</h3>
                    <p className="text-sm text-gray-600">12 aya kadar vade farksız taksit imkanı.</p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibent text-gray-700 mb-4">Cayma Hakkı</h2>
                <div className="space-y-4 text-gray-600">
                  <p>
                    Tüketici Hakları Kanunu uyarınca, tüketicinin mesafeli satış sözleşmesinden cayma hakkı vardır.
                    Bu hak, ürünün teslim edildiği tarihten itibaren 14 gün içerisinde kullanılabilir.
                  </p>
                  <p>
                    <strong>Cayma hakkı kullanılamayan durumlar:</strong>
                  </p>
                  <ul className="list-disc list-inside ml-4 space-y-1">
                    <li>Özel üretim ürünler</li>
                    <li>Hijyen açısından uygun olmayan ürünler</li>
                    <li>Değeri düşen veya bozulan ürünler</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">İletişim</h2>
                <div className="bg-gold-50 p-6 rounded-lg">
                  <p className="text-gray-600 mb-4">
                    Sorularınız için bizimle iletişime geçebilirsiniz:
                  </p>
                  <div className="space-y-2 text-gray-700">
                    <p><strong>Telefon:</strong> 0531 603 68 91</p>
                    <p><strong>E-posta:</strong> info@eminkuyumculuk.com.tr</p>
                    <p><strong>Çalışma Saatleri:</strong> Pazartesi - Cumartesi 09:00 - 19:00</p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}